import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Layout from '../components/layout'
import Nav from '../components/nav'
import SEO from '../components/seo'
import FaqCard from '../components/content/faqCard'
import '../styles/index.scss'

import OptBtn from '../components/button'

// Content components
import Integrations from '../components/content/integrations'
import Stories from '../components/stories'

// images
import agent_view from '../images/products/multiagentes/agent_gif.gif'

// channels
import bannerImg from '../images/home/redesign01/banner-home.png'
import u01Img from '../images/home/redesign01/u01.png'
import u02Img from '../images/home/redesign01/u02.png'
import u03Img from '../images/home/redesign01/u03.png'
import u04Img from '../images/home/redesign01/u04.png'
import u05Img from '../images/home/redesign01/u05.png'
import u06Img from '../images/home/redesign01/u06.png'
import mobile from '../images/home/redesign01/mobile.png'

// customers
import customer_aldeas from '../images/home/clients/customer_aldeas.png'
import customer_baristi from '../images/home/clients/customer_baristi.png'
import customer_ccti from '../images/home/clients/customer_ccti.png'
import customer_conoc from '../images/home/clients/customer_conoc.png'
import customer_crucijuegos from '../images/home/clients/customer_crucijuegos.png'
import customer_descuentos from '../images/home/clients/customer_descuentos.png'
import customer_ginza from '../images/home/clients/customer_ginza.png'
import customer_ioimporto from '../images/home/clients/customer_ioimporto.png'
import customer_mcc from '../images/home/clients/customer_mcc.png'
import customer_med from '../images/home/clients/customer_med.png'
import customer_reba from '../images/home/clients/customer_reba.png'
import customer_san_lorenzo from '../images/home/clients/customer_san_lorenzo.png'
import customer_whyline from '../images/home/clients/customer_whyline.png'
import customer_xe_seguridad from '../images/home/clients/customer_xe_seguridad.png'

function Multiagente ({ lang }) {
    const text = {
        es: {
            cs_jobTitle_1: 'CEO en Reba',
            cs_title_1:
                'La mejor plataforma para atención automatizada y centralizada en WhatsApp',
            cs_description_1:
                'Encontramos en Optiwe el partner ideal para mejorar significativamente la experiencia de servicio a nuestros clientes. En solo unos pocos meses pudimos automatizar el 40% de los mensajes/preguntas de nuestros clientes y ofrecer atención personalizada con AI 24x7.',
            cs_jobTitle_2: 'Asesora de Campaña',
            cs_title_2: 'El mejor CRM para WhatsApp',
            cs_description_2:
                'En Optiwe encontramos el partner ideal para escalar nuestro servicio al donante a través de nuestro sitio web y WhatsApp. También, gracias a sus herramientas de outbound, podemos comunicarnos con nuevos potenciales donantes en tiempo real y brindarles la mejor experiencia posible. Estamos muy felices de contar con la tecnología de Optiwe para potenciar a nuestros equipos de atención al donante.',
            page_title:
                'Optiwe - WhatsApp Multiagente y CRM para Atención de Clientes',
            page_description:
                'Plataforma multiagente y multicanal para atención de clientes y ventas en WhatsApp, Instagram, Facebook Messenger y LiveChat.',
            page_lang: 'es',
            h1_normal:
                'Aumenta tus ventas y atiende mejor a tus clientes con WhatsApp Multiagente',
            h1_description_1:
                'Atiende a tus clientes en Whatsapp, Facebook, Instagram y Web LiveChat con nuestra plataforma para WhatsApp Multi Agente. Ten a todo tu equipo de ventas y soporte al cliente colaborando en línea con WhatsApp Multidispositivo, atendiendo a tus clientes desde un único número de WhatsApp centralizado y sin límite de dispositivos. Puedes monitorear en tiempo real todas las conversaciones con tus clientes y optimizar tus procesos de ventas. ',
            demo: 'Agendar demo',
            test: 'Probar gratis',
            customers:
                'Sumate a las empresas que ya usan nuestro WhatsApp Multi Agente y Multi Dispositivo para hacer crecer sus negocios y mejorar la comunicación con sus clientes',
            h2_benefits: 'Plataforma multiagente con un único número de WhatsApp',
            h2_benefits_description:
                'Con nuestra plataforma puedes utilizar WhatsApp Varios Dispositivos para conectar a todo tu equipo de ventas y atención al cliente a un único número de WhatsApp',
            h2_benefits_alt: 'Vista de agente de atención de Optiwe',
            h2_productos:
                'WhatsApp multiagente para tu equipo de atención al cliente',
            h2_prod_1_title: 'Chat omnicanal',
            h2_prod_1_description:
                'Atención multiagente en Whatsapp Business, Facebook, Instagram, Web LiveChat',
            h2_prod_1_alt: 'Comunicación omnicanal entre empresas y clientes',
            h2_prod_2_title: 'Bandeja de entrada para tu equipo',
            h2_prod_2_description:
                'Gestión colaborativa con todo tu equipo en línea, segmentado por grupos y utilizando un único número de WhatsApp Business API',
            h2_prod_2_alt: 'Bandeja de entrada multicanal de Optiwe',
            h2_prod_3_title: 'Recomendaciones y respuestas rápidas',
            h2_prod_3_description:
                'Sistema intuitivo y familiar, para que tus representantes comerciales vendan de manera efectiva con respuestas rápidas.',
            h2_prod_3_alt: 'Inteligencia Artificial para recomendación de respuestas',
            h2_prod_4_title: 'Derivación de conversación',
            h2_prod_4_description:
                'Derivación de conversaciones entre agentes de atención y equipos de trabajo',
            h2_prod_4_alt:
                'Interfaz de derivación de conversaciones entre agentes de atención',
            h2_prod_5_title: 'Etiquetas de conversaciones',
            h2_prod_5_description:
                'Categorización de conversaciones mediante etiquetas, notas y filtros de búsqueda.',
            h2_prod_5_alt: 'Etiquetas de conversaciones',
            h2_prod_6_title: 'Archivos multimedia',
            h2_prod_6_description:
                'Envío y recepción de imágenes, audios, archivos pdf, archivos de Excel, ubicación, contactos, etc.',
            h2_prod_6_alt: 'Intercambio de archivos multimedia y mensajes de audio',
            h2_prod_7_title: 'Creación de nuevas conversaciones',
            h2_prod_7_description:
                'Los agentes de atención pueden iniciar conversaciones nuevas con tus clientes y pueden realizar envíos masivos con contenido de marketing y promociones.',
            h2_prod_7_alt: 'Creación de nuevas conversaciones y envíos masivos',
            h2_prod_8_title: 'Software de atención multidispositivo',
            h2_prod_8_description:
                'Funcionamiento tanto en la computadora de escritorio como en dispositivos móviles, con notificaciones y alertas para tus vendedores.',
            h2_prod_8_alt:
                'Soporte para computadoras de escritorio y dispositivos móviles',
            h2_prod_9_title: 'Monitoreo de agentes en tiempo real',
            h2_prod_9_description:
                'Monitoreo en tiempo real para saber cómo están trabajando tus agentes y las conversaciones pendientes de atender.',
            h2_prod_9_alt: 'Reportes sobre como trabajan los agentes de atención',
            h2_prod_10_title: 'Historial de conversaciones',
            h2_prod_10_description:
                'Historial de conversaciones y filtros de búsqueda personalizada por diversos parámetros como número de conversación, etiquetas, fecha y nombre de agente.',
            h2_prod_10_alt: 'Historial centralizado de conversaciones',
            h2_prod_11_title: 'WhatsApp Business API',
            h2_prod_11_description:
                'Atiende a tus clientes y vende tus productos con WhatsApp Business en Varios Dispositivos. Tu número de WhatsApp Business API podrá compartirse entre todos los dispositivos móviles de tus agentes.',
            h2_prod_11_alt:
                'WhatsApp Business API para conectar todo tu equipo a un único número telefónico',
            register: 'Regístrate, es gratis!',
            h2_cs:
                'Las empresas que más venden y mejor atienden a sus clientes ya utilizan Optiwe',
            h2_canales: 'Ventas y soporte omnicanal con WhatsApp Multiagente',
            h2_canales_h3:
                'Comunícate en los canales donde tus clientes te están buscando.',
            h2_canales_description:
                'Utiliza nuestra plataforma de ventas en WhatsApp, Instagram, Facebook, tu sitio web y muchos canales más. Te ayudamos a crear chatbots y reglas de derivación inteligentes a agentes de ventas, para ofrecer la mejor experiencia omnicanal a todos tus clientes!',
            h2_canales_whatsapp_platform: 'Plataforma WhatsApp Business',
            h2_canales_whatsapp_business_api: 'WhatsApp Business API Oficial',
            h2_integrations:
                '¿Qué integraciones ofrece Optiwe?What integrations does Optiwe offer?',
            talk: '¡Hablemos!',
            h2_faq: 'Preguntas Frecuentes',
            faq_1: '¿Cuáles son los beneficios que ofrece Optiwe?',
            faq_1_description:
                'Optiwe es la solución que te permite vender productos y chatear con tus clientes por WhatsApp, Instagram, Facebook y Sitio Web. Con unos pocos clicks puedes integrar todos tus canales digitales en nuestra plataforma, automatizar ventas y preguntas frecuentes de tus clientes, derivar conversaciones a tu equipo de ventas y realizar campañas de marketing por WhatsApp. Nuestra solución es simple de utilizar y al mismo tiempo incluye todas las herramientas de ventas que tu negocio necesita. Encuentra más información en nuestro blog sobre cómo nuestra herramienta se compara con otras empresas como Callbell, B2Chat y Cliengo.',
            faq_2: '¿Puedo usar Optiwe para vender por WhatsApp?',
            faq_2_description:
                'Optiwe te permite gestionar las conversaciones con tus clientes por WhatsApp y vender tus productos o servicios de manera centralizada y ordenada. Con la solución de Optiwe puedes mantener a todo tu equipo de ventas colaborando en un único lugar, monitorear en tiempo real las conversaciones que tus vendedores tienen con tus clientes y mejorar la experience de venta y atención. Tus vendedores pueden usar Optiwe desde sus celulares o computadoras y puedes asignar clientes de manera automática para repartir oportunidades y comisiones entre tus vendedores.',
            faq_3: '¿Puedo usar Optiwe para atender clientes por WhatsApp?',
            faq_3_description:
                'Optiwe cuenta con una bandeja de entrada de conversaciones (similar a una cuenta de email) donde todo tu equipo de atención al cliente puede trabajar de manera colaborativa para resolver todas las consultas de tus clientes. En esta bandeja de conversaciones tu equipo de atención recibirá conversaciones de WhatsApp, Facebook, Instagram, Web Chat y más canales, de manera completamente centralizada y fácil de utilizar. Con la funcionalidad de respuestas rápidas y sugeridas de Optiwe, tu equipo de atención va a trabajar más rápidamente y logrará ofrecer una mejor experiencia a todos tus clientes. Optiwe es la plataforma #1 del mercado para WhatsApp Multiagente y WhatsApp Multidispositivo',
            faq_4: '¿Puedo usar Optiwe en varios dispositivos?',
            faq_4_description:
                'Con Optiwe, puedes conectar a todos tus vendedores y agentes de atención a una única linea de WhatsApp Business. Cada miembro de tu equipo puede utilizar su email y contraseña para ingresar a Optiwe desde su dispositivo móvil y comenzar a responder de manera centralizada los mensajes que tus clientes envían a la línea de WhatsApp Business de tu negocio. Nunca más tendrás que pagar por líneas móviles y teléfonos para tu equipo de atención al cliente, ya que la solución multiplataforma de Optiwe puede ser instalada en sus teléfonos personales sin interferir con el WhatsApp personal de los integrantes de tu equipo. Optiwe te permite fácilmente incorporar WhatsApp Business en Varios Dispositivos a tu negocio sin lïmites en la cantidad de agentes de atención',
            faq_5: '¿Puedo usar Optiwe cómo un CRM para WhatsApp e Instagram?',
            faq_5_description:
                'Optiwe te permite centralizar y monitorear todas las conversaciones que tu equipo de ventas y atención tienen con tus clientes. La información de tus clientes como nombre, teléfono, email y conversaciones queda almacenado de manera segura en nuestra plataforma. Puedes crear etiquetas de conversaciones para darle seguimiento a tus clientes y construir tu embudo de ventas. Cada conversación queda asignada con un número de identificación único que te permite darle seguimiento de manera correcta a los reclamos de tus clients.'
        },
        en: {
            cs_jobTitle_1: 'CEO at Reba',
            cs_title_1:
                'The best platform for automated and centralized attention on WhatsApp',
            cs_description_1:
                "We found in Optiwe the ideal partner to significantly improve the customer service experience. In just a few months, we were able to automate 40% of our customers' messages/questions and offer personalized AI assistance 24x7.",
            cs_jobTitle_2: 'Campaign Advisor',
            cs_title_2: 'The best application for Whatsapp Business Multiple Users',
            cs_description_2:
                "At Optiwe, we found the ideal partner to scale our donor service through our website and WhatsApp. Thanks to their outbound tools, we can communicate with new potential donors in real-time and provide them with the best possible experience. We are very happy to have Optiwe's technology to empower our donor support teams.",
            page_title:
                'Optiwe - Whatsapp Business Multiple Users and CRM for Customer Service and Sales',
            page_description:
                'Multi-agent and multi-channel platform for customer service and sales on WhatsApp, Instagram, Facebook Messenger, and LiveChat.',
            page_lang: 'en',
            h1_normal:
                'Increase your sales and better serve your customers with our platform for Whatsapp Business Multiple Users',
            h1_description_1:
                'Serve your customers on WhatsApp, Facebook, Instagram, and Web LiveChat with our multi-agent and multi-device platform. Have your entire sales and customer support team collaborating online in a Whatsapp Shared Inbox, serving your customers from a single centralized WhatsApp number with Whatsapp Multiple Devices (no device limits). You can monitor in real-time all conversations with your customers and optimize your sales processes.',
            demo: 'Schedule demo',
            test: 'Free trial',
            customers:
                'Join the companies that already use our WhatsApp Business CRM to grow their businesses and improve communication with their customers',
            h2_benefits:
                'Whatsapp Business Multiple Users platform with a single WhatsApp number',
            h2_benefits_description:
                'With our platform, you can connect your entire sales and customer service team to a single WhatsApp number.',
            h2_benefits_alt: "Optiwe's customer service agent view",
            h2_productos: 'Multi-agent WhatsApp for your customer service team',
            h2_prod_1_title: 'Omnichannel chat',
            h2_prod_1_description:
                'Multi-agent customer service on WhatsApp Business, Facebook, Instagram, Web LiveChat',
            h2_prod_1_alt:
                'Omnichannel communication between companies and customers',
            h2_prod_2_title: 'Whatsapp Shared Inbox for your team',
            h2_prod_2_description:
                'Collaborative management with your entire team online, segmented by groups and using a single WhatsApp Business API number',
            h2_prod_2_alt: "Optiwe's multi-channel inbox",
            h2_prod_3_title: 'Recommendations and quick responses',
            h2_prod_3_description:
                'Intuitive and familiar system, so your sales representatives can sell effectively with quick responses.',
            h2_prod_3_alt: 'Artificial Intelligence for recommendation of responses',
            h2_prod_4_title: 'Conversation routing',
            h2_prod_4_description:
                'Routing conversations between customer service agents and work teams',
            h2_prod_4_alt:
                'Conversation routing interface between customer service agents',
            h2_prod_5_title: 'Conversation tags',
            h2_prod_5_description:
                'Categorization of conversations through labels, notes, and search filters.',
            h2_prod_5_alt: "Optiwe's multi-channel inbox",
            h2_prod_6_title: 'Multimedia files',
            h2_prod_6_description:
                'Sending and receiving images, audios, PDF files, Excel files, location, contacts, etc.',
            h2_prod_6_alt: 'Multimedia file exchange and audio messaging',
            h2_prod_7_title: 'Creation of new conversations',
            h2_prod_7_description:
                'Customer service agents can initiate new conversations with your clients and can perform massive shipments with marketing content and promotions.',
            h2_prod_7_alt: 'Creation of new conversations and massive shipments',
            h2_prod_8_title: 'Multidevice customer service software',
            h2_prod_8_description:
                'Works both on desktop computers and mobile devices, with notifications and alerts for your salespeople.',
            h2_prod_8_alt: 'Support for desktop computers and mobile devices',
            h2_prod_9_title: 'Real-time agent monitoring',
            h2_prod_9_description:
                'Real-time monitoring to know how your agents are working and the pending conversations that are waiting for an answer.',
            h2_prod_9_alt: 'Reports on how customer service agents work',
            h2_prod_10_title: 'Conversation history',
            h2_prod_10_description:
                'Conversation history and custom search filters by various parameters such as conversation number, tags, date, and agent name.',
            h2_prod_10_alt: 'Centralized conversation history',
            h2_prod_11_title: 'WhatsApp Business API',
            h2_prod_11_description:
                "Serve your customers and sell your products without device limits. Your WhatsApp Business API number can be shared among all your agents' mobile devices (Whatsapp Multiple Devices).",
            h2_prod_11_alt:
                'WhatsApp Business API to connect your entire team to a single phone number',
            register: "Sign up, it's free!",
            h2_cs:
                'The companies that sell the most and provide the best customer service are already using Optiwe',
            h2_canales: 'Omnichannel sales and support',
            h2_canales_h3:
                'Communicate on the channels where your customers are looking for you.',
            h2_canales_description:
                'Use our sales platform on >WhatsApp, Instagram, Facebook, your website, and many other channels. We help you create smart chatbots and routing rules to sales agents, to offer the best omnichannel experience to all your customers!',
            h2_canales_whatsapp_platform: 'WhatsApp Business Platform',
            h2_canales_whatsapp_business_api: 'Official WhatsApp Business API',
            h2_integrations: 'What integrations does Optiwe offer?',
            talk: "Let's talk!",
            h2_faq: 'Frequently Asked Questions',
            faq_1: 'What benefits does Optiwe offer?',
            faq_1_description:
                'Optiwe is the solution that allows you to sell products and chat with your customers via WhatsApp, Instagram, Facebook, and your website. With a few clicks, you can integrate all your digital channels in our platform, automate sales and frequently asked questions from your customers, route conversations to your sales team, and conduct marketing campaigns via WhatsApp. Our solution is easy to use and at the same time includes all the sales tools your business needs. Find more information on our blog about how our tool compares to other companies like Callbell, B2Chat, and Cliengo.',
            faq_2: 'Can I use Optiwe to sell on WhatsApp?',
            faq_2_description:
                "Optiwe allows you to manage conversations with your customers through WhatsApp and sell your products or services in a centralized and organized way. With Optiwe's solution, you can keep your entire sales team collaborating in one place, monitor in real time the conversations that your salespeople have with your customers, and improve the sales and service experience. Your salespeople can use Optiwe from their phones or computers, and you can automatically assign customers to distribute opportunities and commissions among your salespeople.",
            faq_3: 'Can I use Optiwe to assist customers through WhatsApp?',
            faq_3_description:
                "Optiwe has a conversation Whatsapp Shared Inbox (similar to an email account) where your entire customer service team can work collaboratively to resolve all your customers' inquiries. In this Whatsapp Shared Inbox, your customer service team will receive conversations from WhatsApp, Facebook, Instagram, Web Chat, and more channels, in a completely centralized and easy-to-use way. With Optiwe's quick and suggested response functionality, your customer service team will work more quickly and achieve a better experience for all your customers.",
            faq_4: 'Can I use Optiwe for Whatsapp Multiple Devices?',
            faq_4_description:
                "With Optiwe, you can connect all your salespeople and customer service agents to a single WhatsApp Business line. Each member of your team can use their email and password to log into Optiwe from their mobile device and start centrally responding to messages that your customers send to your business's WhatsApp Business line. You will never again have to pay for mobile lines and phones for your customer service team, as Optiwe's multi-platform solution can be installed on their personal phones without interfering with the personal WhatsApp of your team members.",
            faq_5: 'Can I use Optiwe as a CRM for WhatsApp and Instagram?',
            faq_5_description:
                "Optiwe allows you to centralize and monitor all the conversations that your sales and customer service team have with your customers. Your customers' information, such as name, phone number, email, and conversations, is securely stored on our platform. You can create conversation tags to follow up with your customers and build your sales funnel. Each conversation is assigned a unique identification number that allows you to correctly track your customers' claims."
        }
    }

    /*
    ***************
    * SLIDER SETTINGS *
    ***************
    */
    const sliderSettings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    autoplay: true,
                    speed: 2000,
                    autoplaySpeed: 2000,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    autoplay: true,
                    speed: 2000,
                    autoplaySpeed: 2000,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            }
        ]
    }

    function renderSignUpButton (buttonText) {
        if (lang === 'en') {
            return (
                <OptBtn isLink rounded small href="/sign-up/">
                    {text[lang][buttonText]}
                </OptBtn>
            )
        }

        if (lang === 'es') {
            return (
                <OptBtn isLink rounded small href="/es/crear-cuenta/">
                    {text[lang][buttonText]}
                </OptBtn>
            )
        }

        throw new Error('Language not supported')
    }

    /*
    *********************
    * CUSTOMERS STORIES *
    *********************
    */
    const clientStories = [
        {
            id: '1',
            name: 'Stefano Angeli',
            jobTitle: text[lang].cs_jobTitle_1,
            title: text[lang].cs_title_1,
            description: text[lang].cs_description_1,
            img: customer_reba,
            stars: 5
        },
        {
            id: '2',
            name: 'Noelia Nuñez',
            jobTitle: text[lang].cs_jobTitle_2,
            title: text[lang].cs_title_2,
            description: text[lang].cs_description_2,
            img: customer_aldeas,
            stars: 5
        }
    ]

    return (
        <Layout lang={lang}>
            <SEO
                title={text[lang].page_title}
                description={text[lang].page_description}
                lang={text[lang].page_lang}
                locales={[
                    {
                        hreflang: 'en',
                        href: 'https://optiwe.com/products/shared-whatsapp-inbox/'
                    },
                    {
                        hreflang: 'es',
                        href: 'https://optiwe.com/es/productos/whatsapp-multiagente/'
                    },
                    {
                        hreflang: 'x-default',
                        href: 'https://optiwe.com/products/shared-whatsapp-inbox/'
                    }
                ]}
            />

            <main className="container-fluid ow-banner">
                {/*
                ^*********
                * HEADER *
                **********
                */}
                <Nav
                    lang={lang}
                    showButtons
                />

                {/*
                ***************
                * MAIN BANNER *
                ***************
                * TODO: If the banner is used in another view, create a <Banner /> component
                */}
                <div className="container ow-banner__content">
                    <div className="row">
                        <div className="col-xl-6 col-xxl-6 ow-banner__home-content">
                            <h1 className="ow-banner__title">{text[lang].h1_normal}</h1>
                            <p className="ow-banner__text">
                                {text[lang].h1_description_1}
                            </p>
                            <div className="row">
                                <div className="col-xl-4 mb-3 mb-md-3">
                                    {
                                        renderSignUpButton('demo')
                                    }
                                </div>
                                <div className="col-xl-4">
                                    {
                                        renderSignUpButton('test')
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xxl-7 ow-banner__home-image">
                            <img src={bannerImg} alt="optiwe" className="ow-banner__img" />
                        </div>
                    </div>
                </div>
            </main>

            <section
                className="container-fluid ow-section ow-section--features"
                id="features"
            >
                <div className="container success-stories">
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-10">
                            <h2 className="ow-section__title">
                                <span className="bold">{text[lang].customers}</span>
                            </h2>
                        </div>
                        <div className="row">
                            <div className="col-md-10"></div>
                        </div>
                    </div>
                    <div className="mb-5">
                        <Slider {...sliderSettings}>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_aldeas}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_baristi}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_reba}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_ccti}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_conoc}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_crucijuegos}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_descuentos}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_ginza}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_ioimporto}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_mcc}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_med}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_san_lorenzo}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_whyline}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_xe_seguridad}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>

            {/*
            ****************
            * Key benefit  *
            ****************
            */}
            <section className="benefits-shapes">
                <svg
                    id="benefits_top_shape"
                    data-name="benefits_top_shape"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 143.11"
                >
                    <path
                        className="benefits_top_shape"
                        d="M1920,143.11V38.75C1692.68,104.88,1412.86,127.9,1184.41,89,1083.28,71.8,983,44.3,880.43,45.1,705.88,46.4,536.94,129.6,363.09,114c-77.32-7-151.94-33.2-229.26-39.5C89,70.85,41.09,75.79,0,92.94l.22,50.16Z"
                    />
                    <path
                        className="benefits_top_shape"
                        d="M384,72.49c5.25-.88,10.65-1.89,15.23-4.62s8.23-7.75,7.92-13-4.74-9.86-9.87-11.6-10.8-1-15.93.58c-4,1.19-8.2,3-12.06,1.58-4.14-1.57-6.17-6-8.85-9.53C353,25.85,337.1,22.4,327.17,30c-6,4.54-9.81,15.35-7.06,22.55a25.66,25.66,0,0,0,5.42,8c6.64,6.93,17.09,14.23,27,15.22S374,74.25,384,72.49Z"
                    />
                    <path
                        className="benefits_top_shape"
                        d="M443.55,31.61c3.18-3.33,5.56-8.65,2.74-12.32-2.34-3-7.15-3-10.31-.93-1.72,1.09-4.24,3.37-4.92,5.41-1.2,3.23-1.83,9.65,1.81,11.43C436.71,37.19,440.95,34.38,443.55,31.61Z"
                    />
                </svg>
                <div className="container-fluid ow-section--cards" id="benefits">
                    <div className="container">
                        <h2 className="ow-section--cards__title">
                            <span className="bold">{text[lang].h2_benefits}</span>
                        </h2>
                        <p className="ow-section--cards__desc">
                            {text[lang].h2_benefits_description}
                        </p>
                        <img
                            src={agent_view}
                            alt={text[lang].h2_benefits_alt}
                            className="img-responsive"
                        />
                    </div>
                </div>
                <svg
                    id="benefits_bottom_shape"
                    className="benefits_bottom_shape"
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 143.11"
                    data-name="benefits_bottom_shape"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        className="benefits_bottom_shape"
                        d="M0,0V25.07C100.42,73.33,222.92,85.71,339.3,81.39c156.8-5.8,310.1-35.9,467.5-35.3,150.2.5,300.5,20.5,450.6,13.9,134.5-5.9,267.1-42.9,402.7-27.6,84,9.52,172.75,28.69,259.9,33.2V0Z"
                    />
                </svg>
            </section>

            {/*
            ************
            * FEATURES *
            ************
            */}
            <section
                className="container-fluid ow-section ow-section--features"
                id="features"
            >
                <div className="container features">
                    <div className="row">
                        <div className="col-md-12 features__content">
                            <h2 className="ow-section__title">
                                <span className="bold">{text[lang].h2_productos}</span>
                            </h2>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_1_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_1_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u01Img}
                                alt={text[lang].h2_prod_1_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_2_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_2_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u04Img}
                                alt={text[lang].h2_prod_2_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_3_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_3_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u02Img}
                                alt={text[lang].h2_prod_3_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_4_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_4_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u05Img}
                                alt={text[lang].h2_prod_4_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_5_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_5_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u03Img}
                                alt={text[lang].h2_prod_5_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_6_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_6_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u04Img}
                                alt={text[lang].h2_prod_6_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_7_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_7_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u01Img}
                                alt={text[lang].h2_prod_7_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_8_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_8_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u02Img}
                                alt={text[lang].h2_prod_8_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_9_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_9_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u05Img}
                                alt={text[lang].h2_prod_9_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_10_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_10_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u06Img}
                                alt={text[lang].h2_prod_10_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_11_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_11_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u01Img}
                                alt={text[lang].h2_prod_11_alt}
                            />
                        </div>
                    </div>

                    <div className="features__cta mt-5 mb-5">
                        {
                            renderSignUpButton('register')
                        }
                    </div>
                </div>
            </section>

            {/*
            ************
            * CUSTOMERS *
            ************
            */}
            <section className="clients-shapes">
                <div className="client_top_shape_wrapper">
                    <svg
                        className="svg_top_shape"
                        id="client_top_shape"
                        data-name="client_top_shape"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMidYMid slice"
                        viewBox="0 0 1920 595"
                    >
                        <path
                            className="clients_top_shape"
                            d="M1920,595V0c-89.19,9.65-163.93,79.77-218.34,153.38-59,79.8-107.78,170.9-189.35,227.3-42.59,29.6-92,47.9-142.07,60.9-54.28,14.1-110.67,22.1-166.55,17.3-88.88-7.6-172.16-47.2-260.44-59.5a433,433,0,0,0-255.13,43c-37.89,19.4-72.78,44.3-110.57,63.9C472.28,561,345,571.38,232.24,534.68,151.25,508.33,76.61,458.85,0,420.92V595Z"
                        />
                    </svg>
                </div>
                <div
                    className="container-fluid ow-section ow-section--success-stories"
                    id="success-stories"
                >
                    <div className="container success-stories">
                        <div className="row justify-content-center mb-5">
                            <div className="col-md-10">
                                <h2 className="ow-section__title">
                                    <span className="bold">{text[lang].h2_cs}</span>
                                </h2>
                            </div>
                            <div className="row">
                                <div className="col-md-10"></div>
                            </div>
                        </div>
                        <Stories stories={clientStories} />
                    </div>
                </div>
                <svg
                    id="client_bottom_shape"
                    data-name="client_bottom_shape"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1920 170"
                >
                    <path
                        className="client_bottom_shape"
                        d="M0,0V126.36c143.66,40.06,284.7,51.63,445.48,4.58,236.34-69.2,456.88-50.6,696.62-15.6,149.46,21.9,301.72,27,451.88,8.7,111.21-13.59,217-45.86,326-64.76V0Z"
                    />
                </svg>
            </section>

            {/*
            ************
            * CHANNELS *
            ************
            */}
            <section
                className="container-fluid ow-section ow-section--channels"
                id="channels"
            >
                <div className="container">
                    <div className="row d-flex align-items">
                        <div className="col-md-6 d-flex align-items-center order-1 order-ms-2">
                            <div className="ow-section__content">
                                <h2 className="ow-section__title">
                                    <span className="bold">{text[lang].h2_canales}</span>
                                </h2>
                                <h3 className="ow-section__subtitle">
                                    {text[lang].h2_canales_h3}
                                </h3>
                                <p className="ow-section__text">
                                    {text[lang].h2_canales_description}
                                </p>
                                <div className="row ow-section--channels__btn">
                                    {
                                        renderSignUpButton('test')
                                    }
                                </div>
                                <div className="row ow-section--channels__btn">
                                    <OptBtn
                                        isLink
                                        href="https://business.whatsapp.com/products/business-platform"
                                        rounded
                                        small
                                        className="ws-button"
                                    >
                                        {text[lang].h2_canales_whatsapp_platform}
                                    </OptBtn>
                                </div>
                                <div className="row ow-section--channels__btn">
                                    <OptBtn
                                        isLink
                                        href="https://developers.facebook.com/docs/whatsapp/"
                                        rounded
                                        small
                                        className="ws-button"
                                    >
                                        {text[lang].h2_canales_whatsapp_business_api}
                                    </OptBtn>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 order-2 order-md-1">
                            <img src={mobile} alt="Optiwe" className="img-responsive" />
                        </div>
                    </div>
                </div>
            </section>

            {/*
            ****************
            * INTEGRATIONS *
            ****************
            */}
            <section className="integrations-shapes">
                <svg
                    id="integrations_top_shape"
                    data-name="integrations_top_shape 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1920 88"
                >
                    <path
                        className="integrations_top_shape"
                        d="M1920.5,88V43.27C1753,54.14,1581.09,22.09,1411.3,8.49a2363.54,2363.54,0,0,0-388.3,1c-107.6,9.2-212.8,28.4-321.2,34.8-102.5,6.1-195.5,5.9-297.8-3.9C276.5,28.13,126.69,6.36.5,30.37V88Z"
                    />
                </svg>
                <div
                    className="container-fluid ow-section ow-section--clients"
                    id="integrations"
                >
                    <div className="container">
                        <h2 className="ow-section--clients__title">
                            <span className="bold">{text[lang].h2_integrations}</span>
                        </h2>
                        <Integrations />
                    </div>
                </div>
                <svg
                    id="integrations_bottom_shape"
                    data-name="integrations_bottom_shape"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1920 82.17"
                >
                    <path
                        className="integrations_bottom_shape"
                        d="M0,0V25.07C100.42,73.33,222.92,85.71,339.3,81.39c156.8-5.8,310.1-35.9,467.5-35.3,150.2.5,300.5,20.5,450.6,13.9,134.5-5.9,267.1-42.9,402.7-27.6,84,9.52,172.75,28.69,259.9,33.2V0Z"
                    />
                </svg>
            </section>

            <section className="benefits-shapes">
                <svg
                    id="benefits_top_shape"
                    data-name="benefits_top_shape"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 143.11"
                >
                    <path
                        className="benefits_top_shape"
                        d="M1920,143.11V38.75C1692.68,104.88,1412.86,127.9,1184.41,89,1083.28,71.8,983,44.3,880.43,45.1,705.88,46.4,536.94,129.6,363.09,114c-77.32-7-151.94-33.2-229.26-39.5C89,70.85,41.09,75.79,0,92.94l.22,50.16Z"
                    />
                    <path
                        className="benefits_top_shape"
                        d="M384,72.49c5.25-.88,10.65-1.89,15.23-4.62s8.23-7.75,7.92-13-4.74-9.86-9.87-11.6-10.8-1-15.93.58c-4,1.19-8.2,3-12.06,1.58-4.14-1.57-6.17-6-8.85-9.53C353,25.85,337.1,22.4,327.17,30c-6,4.54-9.81,15.35-7.06,22.55a25.66,25.66,0,0,0,5.42,8c6.64,6.93,17.09,14.23,27,15.22S374,74.25,384,72.49Z"
                    />
                    <path
                        className="benefits_top_shape"
                        d="M443.55,31.61c3.18-3.33,5.56-8.65,2.74-12.32-2.34-3-7.15-3-10.31-.93-1.72,1.09-4.24,3.37-4.92,5.41-1.2,3.23-1.83,9.65,1.81,11.43C436.71,37.19,440.95,34.38,443.55,31.61Z"
                    />
                </svg>
                <div className="container-fluid ow-section ow-section--faq">
                    <div className="container">
                        <div className="table-pricing-title">
                            <h2 className="ow-section__title">
                                <span className="bold">{text[lang].h2_faq}</span>
                            </h2>
                        </div>
                        <FaqCard
                            _isOpen={true}
                            title={text[lang].faq_1}
                            text={text[lang].faq_1_description}
                        />
                        <FaqCard
                            _isOpen={true}
                            title={text[lang].faq_2}
                            text={text[lang].faq_2_description}
                        />
                        <FaqCard
                            _isOpen={true}
                            title={text[lang].faq_3}
                            text={text[lang].faq_3_description}
                        />
                        <FaqCard
                            _isOpen={true}
                            title={text[lang].faq_4}
                            text={text[lang].faq_4_description}
                        />
                        <FaqCard
                            _isOpen={true}
                            title={text[lang].faq_4}
                            text={text[lang].faq_5_description}
                        />
                    </div>
                </div>
            </section>
        </Layout>
    )
}
export default Multiagente
